import { NestedModel } from "../nestedmodel";
import { TsmApi } from "../../index";
import has from "lodash/has";
import { debug_error } from "../../logger";
import { DeltaResp } from "./deltaResp";

/*
const requestData = {
    "parameterObjectNamesToDelete": [
        ""
    ],
    "parameterObjectNamesToAdd": [
        ""
    ],
    "parametersToSet": [
        {
            "name": "",
            "value": "",
            "type": ""
        }
    ],
    "taskResultTimeoutSecs": 0
};
*/
/*
const response = {
    "deleteParamResults": [
        {
            "paramName": "",
            "errorMsg": ""
        }
    ],
    "addParamResults": [
        {
            "paramName": "",
            "errorMsg": ""
        }
    ],
    "setParamsResult": {
        "paramName": "",
        "errorMsg": ""
    },
    "dataModelTree": [
        {
            "key": "",
            "data": {
                "label": "",
                "paramName": "",
                "paramValue": "",
                "paramType": "",
                "setSupported": false,
                "addSupported": false,
                "deleteSupported": false
            },
            "children": [
                "DeviceDataModelTreeNode"
            ]
        }
    ],
    "taskResultInfo": {
        "href": "",
        "type": "",
        "taskId": "",
        "pollIntervalMs": 0
    },
    "deviceStatus": {
        "state": "",
        "acsLastContactTimeMs": 0,
        "acsLastContactTimeStr": "",
        "acsCurrentTimeMs": 0,
        "acsCurrentTimeStr": "",
        "lastMonitorTimeMs": 0,
        "lastMonitorTimeStr": ""
    },
    "error": {
        "status": 0,
        "code": 0,
        "category": "",
        "message": "",
        "stackTrace": ""
    }
};
*/

export class CpeId extends NestedModel {
    constructor(props, attributes) {
        super(props, Object.assign({}, attributes));
        this.cpeId = props.value;
        this.deltaResp = new DeltaResp({value: 'deltaResp', parent: this});
    }

    getApi() {
        const url = new URL(this.get('request_url').split(this.parent.url())[0]);
        const apiPath = url.pathname;
        return new TsmApi(apiPath);
    }

    save({ requestData }) {
        if (!requestData) {
            throw new Error('requestData is required');
        }

        const api = this.getApi();

        const poll = async (data) => {
            if (!has(data, 'taskResultInfo')) {
                return data;
            }
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    console.log('Polling:', data);
                    api.tasks.taskId(data.taskResultInfo.taskId).featureSetDeviceTask.fetch()
                        .then(poll)
                        .then(resolve)
                        .catch(reject);
                }, data.taskResultInfo.pollIntervalMs);
            });
        };


        // return super.save(attributes, options)
        return this.fetch({ method: 'POST', data: requestData })
            .then(poll)
            .catch(error => {
                debug_error(error);
                throw error;
            });
    }
}
